import { FC } from 'react';

import { BoardVideo } from 'types';
import VideoRow from './VideoRow';

type VideosListProps = {
  videos: BoardVideo[];
  hasOptions?: boolean;
  isAdminView?: boolean;
  onViewVideo: (videoId: string) => void; // eslint-disable-line no-unused-vars
  onRenameVideo?: (videoId: string) => void; // eslint-disable-line no-unused-vars
  onDeleteVideo?: (videoId: string) => void; // eslint-disable-line no-unused-vars
  textSize?: number;
};

const VideosList: FC<VideosListProps> = ({
  videos,
  hasOptions = true,
  isAdminView,
  onViewVideo,
  onRenameVideo,
  onDeleteVideo,
  textSize,
}) =>
  videos?.map((video) => (
    <VideoRow
      key={`video-${video.videoId}`}
      video={video}
      hasOptions={hasOptions}
      isAdminView={isAdminView}
      onViewVideo={onViewVideo}
      onRenameVideo={onRenameVideo}
      onDeleteVideo={onDeleteVideo}
      textSize={textSize}
    />
  ));

export default VideosList;
